module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av440-9da0ccfb5c318916a80e741e32e2bcb1.jpg";